import script from "./icon-profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-profile.vue?vue&type=script&lang=ts&setup=true"

import "./icon-profile.vue?vue&type=style&index=0&id=16bd4c77&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16bd4c77"]])

export default __exports__